module.exports = __webpack_public_path__ + "fonts/Inter-100-cyrillic-ext22.df55b7e.woff2";